import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { sendContact } from "../lib/api";

const Contact = () => {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await sendContact(form);
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="pt-28 md:pt-36 pb-24" data-testid="page-contact">
      <section className="px-6 md:px-12 lg:px-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline mb-5">{t.nav.contact}</p>
          <h1 className="font-serif-display text-5xl md:text-6xl font-light text-[#1E2B3C] leading-[1.02]">
            {t.contact.title}
          </h1>
          <p className="mt-6 text-[#5C5C5C] leading-relaxed max-w-md">{t.contact.sub}</p>

          <div className="mt-12 space-y-1 text-sm">
            <p className="overline text-[10px]">Email</p>
            <a
              href="mailto:contact@lamaisonmarigold.com"
              className="font-serif-display text-2xl md:text-3xl text-[#1E2B3C] hover:text-[#B34A36] transition-colors"
              data-testid="contact-email-link"
            >
              contact@lamaisonmarigold.com
            </a>
          </div>
        </div>

        <form onSubmit={onSubmit} className="lg:col-span-7 space-y-5" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <label className="overline text-[10px] block mb-2">{t.contact.name}</label>
              <input
                required
                value={form.name}
                onChange={onChange("name")}
                className="w-full bg-transparent border-b border-[#1E2B3C]/40 py-3 focus:outline-none focus:border-[#B34A36] transition-colors"
                data-testid="contact-name"
              />
            </div>
            <div>
              <label className="overline text-[10px] block mb-2">{t.contact.email}</label>
              <input
                required
                type="email"
                value={form.email}
                onChange={onChange("email")}
                className="w-full bg-transparent border-b border-[#1E2B3C]/40 py-3 focus:outline-none focus:border-[#B34A36] transition-colors"
                data-testid="contact-email"
              />
            </div>
          </div>
          <div>
            <label className="overline text-[10px] block mb-2">{t.contact.message}</label>
            <textarea
              required
              rows={6}
              value={form.message}
              onChange={onChange("message")}
              className="w-full bg-transparent border-b border-[#1E2B3C]/40 py-3 focus:outline-none focus:border-[#B34A36] transition-colors resize-none"
              data-testid="contact-message"
            />
          </div>
          <button
            type="submit"
            disabled={status === "loading"}
            className="btn-primary disabled:opacity-60"
            data-testid="contact-submit"
          >
            {t.contact.send}
          </button>
          {status === "success" && (
            <p className="text-[#B34A36] text-sm" data-testid="contact-success">
              {t.contact.success}
            </p>
          )}
        </form>
      </section>
    </div>
  );
};

export default Contact;
